import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgYearInReviewLogoFull } from "@ugitgud/legos/ui/icon/SVG/year-in-review/YearInReviewLogoFull";
import { SvgYearInReviewTextFull } from "@ugitgud/legos/ui/icon/SVG/year-in-review/YearInReviewTextFull";

interface YearInReviewFailedProps {
  onRetry?: () => void;
  onContactSupport?: () => void;
}

export const YearInReviewNoMatches = ({ onRetry, onContactSupport }: YearInReviewFailedProps) => {
  return (
    <div className="flex flex-col items-center gap-[24px]">
      <div className="flex space-x-[19px] justify-center">
        <Icon icon={<SvgYearInReviewLogoFull />} className="w-[104.273px] h-[100px]" />
        <div className="flex flex-col space-y-[20px]">
          <Icon icon={<SvgYearInReviewTextFull />} className="w-[156.779px] h-[76.266px]" />
          <div className="w-[154.933px] h-[3.35px] bg-[#D3A752] drop-shadow-[0_2px_2px_rgba(0,0,0,0.25)] border-0" />
        </div>
      </div>
      <h1 className="text-center text-[48px] font-medium uppercase leading-normal tracking-normal drop-shadow-[0_2px_2px_rgba(0,0,0,0.40)] font-[Barlow] bg-gradient-to-b from-[#F4C874_25%] to-[#D3A752_84%] bg-clip-text text-transparent pt-[24px]">
        No Matches Found
      </h1>
      <div className="text-center text-sm font-normal leading-normal text-[#CDDCFE] font-inter">
        <p>Looks like there were no matches, or not enough matches found on your account.</p>
        <p>
          If you think was a mistake, please try regenerating or{" "}
          <span className="underline text-[#3273FA] cursor-pointer" onClick={onContactSupport}>
            contact support
          </span>
          .
        </p>
      </div>
      {onRetry && (
        <button
          onClick={onRetry}
          className="flex text-white text-[13px] font-bold items-center justify-center min-w-[120px] rounded-[3px] bg-[#3273FA] px-[12px] py-[10px] shadow-[0_2px_2px_0_rgba(0,0,0,0.25)] transition-all duration-200 hover:brightness-125"
        >
          Regenerate
        </button>
      )}
    </div>
  );
};
